import React from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';

const TapInfo = ({ tapDate, onDateChange, tapNumber, onChange, isEditable }) => (
    <div>
        <Row style={{ marginBottom: 20 }}>
            <Col sm={4}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        Tap date
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        {!isEditable && (
                            <p style={{ marginTop: 5 }}>
                                {tapDate ? moment(tapDate).format('DD-MM-YYYY HH:mm') : '-'}
                            </p>
                        )}
                        {isEditable && (
                            <Datetime
                                value={tapDate}
                                onChange={onDateChange('tapDate')}
                                dateFormat="DD-MM-YYYY"
                                timeFormat="HH:mm"
                                inputProps={{ maxLength: 255 }}
                            />
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row>
            <Col sm={4}>
                <Row>
                    <Col sm={4} style={{ marginTop: 10 }}>
                        Tap number
                    </Col>
                    <Col sm={8} style={{ marginTop: 5 }}>
                        {!isEditable && <p style={{ marginTop: 5 }}>{tapNumber || '-'}</p>}
                        {isEditable && (
                            <FormControl
                                type="text"
                                name="tapNumber"
                                maxLength="1000"
                                value={tapNumber}
                                onChange={onChange}
                            />
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
);

export default TapInfo;
